import styled from 'styled-components';

export const BubbleChartContainer = styled.div`
  position: relative;
`;
